module.exports = __webpack_public_path__ + "img/profile2.101c96ca.jpg";